import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import { DLModal } from 'appSrc/components/Shards';
import style from './styles/style.module.css';

const generateStandardEmbedCode = ( listId ) => {
    return (
        `<!-- DesireList embedded carousel *thedesirecompany.com* -->
    <style>#desirelist-carousel-embed-${ listId } {position:relative;display:table;width:100%;margin:auto;max-width:1024px;}#desirelist-carousel-embed-${ listId } iframe {position:relative;width:100%;min-height:280px;max-width:100%;border:none;}</style>
    <div id='desirelist-carousel-embed-${ listId }'></div>
    <script>!function(){var e="desirelist-carousel-embed-${ listId }",t="#"+e,r="${ process.env.REACT_APP_HOST }/embed/index.html?listid=${ listId }",n=function(){var e=function(){var e=document.querySelector(t);try{var r=window.getComputedStyle(e.parentElement).width;e.style.width=r,document.querySelector(t+" iframe").style.width=r}catch(e){console.warn("**DesireList**","iframe resize error")}};window.addEventListener("resize",e),e()},i=function(){new pym.Parent(e,r,{});n()},o=function(){var e=document.querySelector(t),i=document.createElement("iframe");i.src=r,e.appendChild(i),n()};!function(e){var t=document.createElement("script");t.type="text/javascript",t.onerror=function(e){console.warn("**DesireList**","pym script failed to load. Using primary fallback."),o()},t.onload=i,document.currentScript.parentNode.insertBefore(t,document.currentScript),t.src=e}("https://pym.nprapps.org/pym.v1.min.js")}();</script>
<!-- end DesireList embedded carousel -->`
    );
};

const generateSimpleEmbedCode = ( listId ) => {
    return (
        `<!-- DesireList embedded carousel *thedesirecompany.com* -->
    <style>#desirelist-carousel-embed-${ listId } {position:relative;display:table;width:100%;margin:auto;max-width:1024px;}#desirelist-carousel-embed-${ listId } iframe {position:relative;width:100%;min-height:280px;max-width:100%;border:none;}</style>
    <div id='desirelist-carousel-embed-${ listId }'><iframe src="${ process.env.REACT_APP_HOST }/embed/index.html?listid=${ listId }" width="100%" scrolling="no" marginheight="0" frameborder="0" height="280px" style="width: 100%;"></iframe></div>
<!-- end DesireList embedded carousel -->`
    );
};

class EmbedModal extends PureComponent {
    constructor(props) {
        super( props );

        this.standardCode = generateStandardEmbedCode( this.props.listid );
        this.simpleCode = generateSimpleEmbedCode( this.props.listid );

        this.state = {
            copyMessage: '',
            view: 'standard',
        };
    }
    changeView = ( newView ) => {
        this.setState( {
            copyMessage: '',
            view: newView,
        } );
    }
    copyToClipboard = () => {
        try {
            if ( navigator.userAgent.match( /ipad|ipod|iphone/i ) ) {
                var range = document.createRange();
                range.selectNodeContents( this._text );

                var s = window.getSelection();
                s.removeAllRanges();
                s.addRange( range );

                this._text.setSelectionRange(0, 999999);
            } else {
                this._text.select();
            }
            var successful = document.execCommand('copy');
            var msg = successful ? 'Copied' : 'Failed to Copy';
            this.setState( { copyMessage: msg } );
        } catch (err) {
            this.setState( { copyMessage: 'Failed to Copy' } );
        }
        this._text.blur();
    }
    render() {
        return (
            <DLModal className={ style.embedModal }
            title="Embed on your site"
            closeHandler={ this.props.onClose } >
                <div className={ style.tabs }>
                    <span className={ style.tabOption } data-active={ this.state.view == 'standard' }
                    onClick={ () => { this.changeView( 'standard' ); } }>Standard</span>
                    <span className={ style.tabOption } data-active={ this.state.view == 'simple' }
                    onClick={ () => { this.changeView( 'simple' ); } }>Simple</span>
                </div>
                { this.state.view == 'standard' &&
                    <div>
                        <p className={ style.instructions }>Copy and paste the following code into your website:&emsp;&emsp;
                            <FontAwesomeIcon icon={ faCopy } aria-hidden="true" title="Copy code" onClick={ this.copyToClipboard } />&ensp;{ this.state.copyMessage }</p>
                        <pre className={ style.embedCode }>{ this.standardCode }</pre>
                        <textarea className={ style.almostInvisible } ref={ ( el ) => { this._text = el; } } value={ this.standardCode }  contentEditable="true" readOnly></textarea>
                    </div>
                }
                { this.state.view == 'simple' &&
                    <div>
                        <p>This is a simpler version of the embed code, which should be used if
                        your website doesn&apos;t work with our standard embed code.</p><br/>
                        <p className={ style.instructions }>Copy and paste the following code into your website:&emsp;&emsp;
                            <FontAwesomeIcon icon={ faCopy } aria-hidden="true" title="Copy code" onClick={ this.copyToClipboard } />&ensp;{ this.state.copyMessage }</p>
                        <pre className={ style.embedCode }>{ this.simpleCode }</pre>
                        <textarea className={ style.almostInvisible } ref={ ( el ) => { this._text = el; } } value={ this.simpleCode }  contentEditable="true" readOnly></textarea>
                    </div>
                }
            </DLModal>
        );
    }
}
EmbedModal.propTypes = {
    listid: PropTypes.oneOfType( [
        PropTypes.string,
        PropTypes.number,
    ] ).isRequired,
    onClose: PropTypes.func.isRequired,
};

export default EmbedModal;
